export enum SpecialOfferType {
  BUY_X_GET_Y = "BUY_X_GET_Y",
  BUY_X_Y_GET_Z = "BUY_X_Y_GET_Z",
  BUY_X_GET_Y_Z = "BUY_X_GET_Y_Z",
}

export type PromotionDetailType = {
  id: string; // "X", "Y", "Z"
  packagedProductId?: number;
  units: number;
};

export type PromotionType = {
  id: number;
  type: SpecialOfferType;
  notes: string;
  promotionDetails: PromotionDetailType[];
};

export type PromotionsState = {
  promotions: PromotionType[];
  nextPromotionId: number;
};

export const promotionsListChoices = [
  {
    id: SpecialOfferType.BUY_X_GET_Y,
    name: "promotion_xy",
  },
  {
    id: SpecialOfferType.BUY_X_Y_GET_Z,
    name: "promotion_xy_z",
  },
  {
    id: SpecialOfferType.BUY_X_GET_Y_Z,
    name: "promotion_x_yz",
  },
];

export type PackagedProductDetailsType = {
  ppId?: number;
  productPrice: string;
  productPriceNumber: number;
  container: string;
  codigo?: string | null;
  numberOfSubUnits: number;
  volumeHl: number;
};
